import React, { Component } from 'react'
import { Select } from '@driftt/tide-core-legacy'
import { clone } from 'ramda'
import { REVENUE_GROUPS, REVENUE_FILTER_OPERATORS } from 'app/modules/rules/constants'

class RevenueRaised extends Component {
  constructor(props) {
    super(props)

    const initialValue = props.activeFilter.value

    this.state = {
      selected: initialValue
    }
  }

  updateValue = ({ value }) => {
    const {onUpdateCondition, activeFilter} = this.props

    const newFilter = clone(activeFilter)

    newFilter.value = value

    this.setState({
      selected: value
    })

    onUpdateCondition(newFilter)
  }

  render() {
    const { selected } = this.state
    return (
      <div className="rules-choice-content drift-form">
        <div className="rules-choice-options">
          <Select options={REVENUE_GROUPS} onChange={this.updateValue} value={selected} clearable={false}/>
        </div>
      </div>
    )
  }
}

export default RevenueRaised


// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/AnnualRevenueFilter.js